var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":require("../assets/open.jpg"),"alt":""}}),_c('div',{staticClass:"count"},[_vm._v(" "+_vm._s(_vm.count)+"s ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }